export const CHART_BASE_DIMENSION = 'cohort_dt' as const;
